import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import methods from './data/shippingMethods.json';

const fineMethod = (zipCode) => {
  if (zipCode.length < 5) {
    return '';
  }

  const matched = methods.find((x) => x.zipCodes.includes(zipCode));
  return matched ? matched.name : `Sorry, no complimentary local delivery available for this zip code.`;
};

function App() {
  const [zipCode, setZipCode] = useState('');
  const [deliveryMethod, setDeliveryMethod] = useState('');

  const handleSearch = (e) => {
    const zipCode = e.target.value;
    setZipCode(zipCode);
  };

  useEffect(() => {
    const method = fineMethod(zipCode);
    setDeliveryMethod(method);
  }, [zipCode]);

  return (
    <Container fluid>
      <Row className="pt-2 px-3 justify-content-xs-center">
        <Form onSubmit={(e) => e.preventDefault()}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>Find Complimentary Local Delivery by Zip Code</Form.Label>
            <Form.Control
              placeholder="Enter 5 Digits Zip Code Here..."
              maxLength="5"
              value={zipCode}
              onChange={handleSearch}
            />
            <Form.Text className="text-muted">
              Get free local delivery on orders of $100 or more
            </Form.Text>
          </Form.Group>
        </Form>
      </Row>
      <Row className="px-3 justify-content-xs-center">
        {deliveryMethod}
      </Row>
    </Container>
  );
}

export default App;
